import { get } from 'lodash';
import getNewExistingRadioState from '@zocdoc/components/src/newexistingradio/NewExistingRadioSelector';
import { getLocationsCarouselState } from '../../../Shared/LocationCardCarousel/selectors';

export default function mapStateToProps(state) {
    const carouselState = getLocationsCarouselState(state);
    const newExistingRadioState = getNewExistingRadioState(state);

    return {
        carouselLocationId: get(carouselState, 'locationId'),
        isNewPatient: get(newExistingRadioState, 'isNewPatient'),
    };
}
